module App.Interfaces {
    export interface IStoreDate {
        storeId: string;
        date: Date;
    }
}